/**
 * True when the server rendered a valid reseller EmbedContext
 * (`<html data-embed="true">` from `_root.cshtml`).
 */
export function isPageEmbedded(doc: Pick<Document, 'documentElement'> = document): boolean {
  return doc.documentElement.dataset.embed === 'true';
}
